import React, { useState } from 'react';
import { exportToExcel } from 'src/utils/Common';
import { Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

function MaterialExcelExport(JsonData) {
  const { t } = useTranslation('JobControl');

  if (JsonData?.JsonData?.length === 0) {
    return (
      <Button
        size="small"
        variant="contained"
        color="primary"
        disabled={true}
        fullWidth
        endIcon={<CloudDownloadIcon />}
      >
        {t('lblExport')}
      </Button>
    )
  }

  var ExportData = JsonData.JsonData.map(item => {
    return {
      WorkCaseId: item.WorkCaseId,
      Status: item.Status,
      ContactName: item.ContactName,
      ModelCode: item.ModelCode,
      Model: item.Model,
      OpenDate: moment(item.OpenDate).format('DD-MM-YYYY'),
      CreateUser: item.CreateUser,
      UpdateUser: item.UpdateUser,
      UpdateDate: moment(item.UpdateDate).format('DD-MM-YYYY'),
      Feedback:item.FeedbackDescription
    }
  });

  return (
    <>
      <Button
        size="small"
       variant="contained"
         color="primary"
         fullWidth
         endIcon={<CloudDownloadIcon />}
         onClick={() => exportToExcel(ExportData, 'CustomerFeedbackExport') }
       >
        {t('lblExport')}
       </Button>
    </>
  );
}

MaterialExcelExport.propTypes = {

};

export default MaterialExcelExport;
